// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_JZt","cls2":"HeroWorkCardHeader-cls2_bF- HeroWorkCardHeader-cls1_JZt","spacing-compact":"HeroWorkCardHeader-spacing-compact_m_P"};